export default {
  scrolling: 'yes',
  height: '100%',
  width: '100%',
  locale: 'en-US',
  footerPaddingEnabled: true,
  undoRedoDisabled: true,
  resetDisabled: true,
};
